import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useIAChatHeaderStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: spacing.md,
    borderBottom: `1px solid ${colors.chatBorder}`,
    borderBottomLeftRadius: radius.sm,
    borderBottomRightRadius: radius.sm,
    flexShrink: 0,
    backgroundColor: colors.white,
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    flex: 1,
    minWidth: 0,
  },
  headerTitle: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.intro,
    lineHeight: 'normal',
    color: colors.text,
    margin: 0,
  },
  historyLink: {
    border: 0,
    padding: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 'normal',
    color: colors.text,
    textDecoration: 'underline',
    textAlign: 'left',
    '&:hover': {
      opacity: 0.8,
    },
  },
  closeButton: {
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    width: 24,
    height: 24,
    color: colors.text,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      opacity: 0.7,
    },
  },
  closeIcon: {
    width: 24,
    height: 24,
    display: 'block',
  },
  backButton: {
    padding: 0,
    marginRight: spacing.xs,
    color: colors.text,
    flexShrink: 0,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
  },
}));
